import { watch } from 'vue'
import type { Ref } from 'vue'

export interface DateRangeEmits {
  pickupDateSelected: (date: Date) => void
  dropoffDateSelected: (date: Date) => void
}

export function useDateRangeEvents(
  pickupDate: Ref<Date | null>,
  dropoffDate: Ref<Date | null>,
  openDropoffCalendar: () => void,
  closeDropoffCalendar: () => void,
  emit: DateRangeEmits
) {

  // Auto-open dropoff calendar when pickup date is selected
  watch(pickupDate, (newPickup) => {
    if (newPickup) {
      // Reset dropoff date when pickup date changes
      dropoffDate.value = null
      emit.pickupDateSelected(newPickup)
      openDropoffCalendar()
    }
  })

  // Auto-close dropoff calendar when a date is selected
  watch(dropoffDate, (newDropoff) => {
    if (newDropoff) {
      emit.dropoffDateSelected(newDropoff)
      closeDropoffCalendar()
    }
  })
} 